module.exports = __webpack_public_path__ + "img/view-inactive.cb519055.svg";